<section mat-dialog-title>
  <span>Register Device</span>

  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>

<ng-container *ngTemplateOutlet="showWifiSection() ? wifiFlow : registrationFlow" />

<ng-template #registrationFlow>
  <mat-dialog-content>
    <avs-message type="info">
      Make sure the device you want to connect to is in pairing mode. To enable it, press and hold a pair button for
      several seconds until an indicator light starts blinking
    </avs-message>

    <div class="flex flex-row">
      <label class="input-main-label capitalize">
        Building *
      </label>

      <avs-location-selector
        class="flex-1"
        (changed)="building.set($event!)"
      />
    </div>

    <div class="flex flex-row">
      <label class="input-main-label">
        Floor *
      </label>

      <avs-space-selector
        class="flex-1"
        (changed)="floor.set($event!)"
        [location]="building()"
        [type]="eSpaceType.floor"
      />
    </div>

    <div class="flex flex-row">
      <label class="input-main-label">
        Room *
      </label>

      <avs-space-selector
        class="flex-1"
        (changed)="room.set($event!)"
        [location]="building()"
        [parent]="floor()"
        [type]="eSpaceType.room"
      />
    </div>

    <div class="flex flex-row">
      <label class="input-main-label">
        S/N *
      </label>

      <mat-form-field
        class="input-classic flex-1"
        appearance="outline"
      >
        <input
          (input)="serialNumber.set($any($event.target).value)"
          [value]="serialNumber()"
          matInput
          placeholder="Enter S/N"
        />
        <button
          class="group disabled:opacity-50"
          (click)="pair()"
          [disabled]="!browserHelpers.isBluetoothSupported()"
          matSuffix
        >
          <mat-icon
            class="text-[24px] p-0 text-ui-gray-450 group-disabled:text-ui-gray-125"
            fontIcon="bluetooth"
          />
        </button>

        @if (!browserHelpers.isBluetoothSupported()) {
          <mat-hint>S/N scan is available in Chrome</mat-hint>
        }
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions
    class="gap-3"
    align="end"
  >
    <button
      mat-button
      mat-dialog-close
    >
      Cancel
    </button>

    @if (browserHelpers.isBluetoothSupported()) {
      <button
        class="btn-green-stroked btn-medium"
        (click)="registerAndConnect()"
      >
        Register & Connect
      </button>
    }

    <button
      class="btn-green btn-medium"
      (click)="register()"
      [disabled]="!isValid()"
    >
      Register
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #wifiFlow>
  <mat-dialog-content>
    <avs-wifi-picker [deviceId]="registeredDevice()!.id" />
  </mat-dialog-content>

  <mat-dialog-actions
    class="gap-3"
    align="end"
  >
    <button
      mat-button
      mat-dialog-close
    >
      Cancel
    </button>

    @if (wifiPicker().isConnected()) {
      <button
        class="btn-green btn-medium"
        (click)="connect()"
        [disabled]="!wifiPicker().isValid()"
      >
        Connect
      </button>
    }
  </mat-dialog-actions>
</ng-template>
